/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MeResponseDto } from './MeResponseDto';
import {
    MeResponseDtoFromJSON,
    MeResponseDtoFromJSONTyped,
    MeResponseDtoToJSON,
    MeResponseDtoToJSONTyped,
} from './MeResponseDto';
import type { ClaimResponseDto } from './ClaimResponseDto';
import {
    ClaimResponseDtoFromJSON,
    ClaimResponseDtoFromJSONTyped,
    ClaimResponseDtoToJSON,
    ClaimResponseDtoToJSONTyped,
} from './ClaimResponseDto';
import type { InsuredResponseDto } from './InsuredResponseDto';
import {
    InsuredResponseDtoFromJSON,
    InsuredResponseDtoFromJSONTyped,
    InsuredResponseDtoToJSON,
    InsuredResponseDtoToJSONTyped,
} from './InsuredResponseDto';
import type { ReinsuredResponseDto } from './ReinsuredResponseDto';
import {
    ReinsuredResponseDtoFromJSON,
    ReinsuredResponseDtoFromJSONTyped,
    ReinsuredResponseDtoToJSON,
    ReinsuredResponseDtoToJSONTyped,
} from './ReinsuredResponseDto';
import type { ContractResponseDto } from './ContractResponseDto';
import {
    ContractResponseDtoFromJSON,
    ContractResponseDtoFromJSONTyped,
    ContractResponseDtoToJSON,
    ContractResponseDtoToJSONTyped,
} from './ContractResponseDto';
import type { SubmissionResponseDto } from './SubmissionResponseDto';
import {
    SubmissionResponseDtoFromJSON,
    SubmissionResponseDtoFromJSONTyped,
    SubmissionResponseDtoToJSON,
    SubmissionResponseDtoToJSONTyped,
} from './SubmissionResponseDto';

/**
 * 
 * @export
 * @interface BinderClaimResponseDto
 */
export interface BinderClaimResponseDto {
    /**
     * 
     * @type {string}
     * @memberof BinderClaimResponseDto
     */
    claimNo: string;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimResponseDto
     */
    claimId: string;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimResponseDto
     */
    contractId: string;
    /**
     * 
     * @type {SubmissionResponseDto}
     * @memberof BinderClaimResponseDto
     */
    submission?: SubmissionResponseDto;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimResponseDto
     */
    claimStatus: BinderClaimResponseDtoClaimStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimResponseDto
     */
    referenceNo?: string;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimResponseDto
     */
    commentsTo?: string;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimResponseDto
     */
    comments?: string;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimResponseDto
     */
    paymentsOurShare: string;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimResponseDto
     */
    outstandingOurShare: string;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimResponseDto
     */
    incurredOurShare: string;
    /**
     * 
     * @type {InsuredResponseDto}
     * @memberof BinderClaimResponseDto
     */
    insured?: InsuredResponseDto;
    /**
     * 
     * @type {ReinsuredResponseDto}
     * @memberof BinderClaimResponseDto
     */
    reinsured?: ReinsuredResponseDto;
    /**
     * 
     * @type {ClaimResponseDto}
     * @memberof BinderClaimResponseDto
     */
    claim?: ClaimResponseDto;
    /**
     * 
     * @type {ContractResponseDto}
     * @memberof BinderClaimResponseDto
     */
    contract?: ContractResponseDto;
    /**
     * 
     * @type {MeResponseDto}
     * @memberof BinderClaimResponseDto
     */
    claimsHandlerUser?: MeResponseDto;
}


/**
 * @export
 */
export const BinderClaimResponseDtoClaimStatusEnum = {
    PreCautionary: 'Pre-cautionary',
    Registered: 'Registered',
    InProgress: 'In-progress',
    Closed: 'Closed'
} as const;
export type BinderClaimResponseDtoClaimStatusEnum = typeof BinderClaimResponseDtoClaimStatusEnum[keyof typeof BinderClaimResponseDtoClaimStatusEnum];


/**
 * Check if a given object implements the BinderClaimResponseDto interface.
 */
export function instanceOfBinderClaimResponseDto(value: object): value is BinderClaimResponseDto {
    if (!('claimNo' in value) || value['claimNo'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    if (!('claimStatus' in value) || value['claimStatus'] === undefined) return false;
    if (!('paymentsOurShare' in value) || value['paymentsOurShare'] === undefined) return false;
    if (!('outstandingOurShare' in value) || value['outstandingOurShare'] === undefined) return false;
    if (!('incurredOurShare' in value) || value['incurredOurShare'] === undefined) return false;
    return true;
}

export function BinderClaimResponseDtoFromJSON(json: any): BinderClaimResponseDto {
    return BinderClaimResponseDtoFromJSONTyped(json, false);
}

export function BinderClaimResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BinderClaimResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNo': json['claimNo'],
        'claimId': json['claimId'],
        'contractId': json['contractId'],
        'submission': json['submission'] == null ? undefined : SubmissionResponseDtoFromJSON(json['submission']),
        'claimStatus': json['claimStatus'],
        'referenceNo': json['referenceNo'] == null ? undefined : json['referenceNo'],
        'commentsTo': json['commentsTo'] == null ? undefined : json['commentsTo'],
        'comments': json['comments'] == null ? undefined : json['comments'],
        'paymentsOurShare': json['paymentsOurShare'],
        'outstandingOurShare': json['outstandingOurShare'],
        'incurredOurShare': json['incurredOurShare'],
        'insured': json['insured'] == null ? undefined : InsuredResponseDtoFromJSON(json['insured']),
        'reinsured': json['reinsured'] == null ? undefined : ReinsuredResponseDtoFromJSON(json['reinsured']),
        'claim': json['claim'] == null ? undefined : ClaimResponseDtoFromJSON(json['claim']),
        'contract': json['contract'] == null ? undefined : ContractResponseDtoFromJSON(json['contract']),
        'claimsHandlerUser': json['claimsHandlerUser'] == null ? undefined : MeResponseDtoFromJSON(json['claimsHandlerUser']),
    };
}

export function BinderClaimResponseDtoToJSON(json: any): BinderClaimResponseDto {
    return BinderClaimResponseDtoToJSONTyped(json, false);
}

export function BinderClaimResponseDtoToJSONTyped(value?: BinderClaimResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimNo': value['claimNo'],
        'claimId': value['claimId'],
        'contractId': value['contractId'],
        'submission': SubmissionResponseDtoToJSON(value['submission']),
        'claimStatus': value['claimStatus'],
        'referenceNo': value['referenceNo'],
        'commentsTo': value['commentsTo'],
        'comments': value['comments'],
        'paymentsOurShare': value['paymentsOurShare'],
        'outstandingOurShare': value['outstandingOurShare'],
        'incurredOurShare': value['incurredOurShare'],
        'insured': InsuredResponseDtoToJSON(value['insured']),
        'reinsured': ReinsuredResponseDtoToJSON(value['reinsured']),
        'claim': ClaimResponseDtoToJSON(value['claim']),
        'contract': ContractResponseDtoToJSON(value['contract']),
        'claimsHandlerUser': MeResponseDtoToJSON(value['claimsHandlerUser']),
    };
}

